export type RoundingFunction = (value: number) => number;
export enum Joule {
  UNIT = 'kJ',
  CONVERSION = 4.184,
}
